import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MenuComponent } from '../MenuComponent';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';

export class Transfer extends Component {
    static displayName = Transfer.name;

    constructor(props) {
        super(props);
        this.history = props.history;
        this.state = {
            alertMessage: "",
            unfinalisedDockets: [],
            selectedDocket: "",
            selectedNamecode: "",
            selectedClient: "",
            selectedReference: "",
            selectedCreatedDate: ""
        }
    }

    componentDidMount() {
        this.loadUnfinalisedDockets();
        this.refs.namecodeInput.focus();
        this.initialiseRF_TransferGlobalVariables();
    }
    clearAll() {
        this.setState({
            selectedDocket: "",
            selectedNamecode: "",
            selectedReference: "",
            selectedCreatedDate: "",
            selectedClient: ""
        });
    }

    async loadUnfinalisedDockets() {
        var warehouseID = MyGlobal.warehouse;
        fetch(`api/Transfer/GetUnfinalisedDockets?warehouseID=${warehouseID}`)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson ? await response.json() : null;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ unfinalisedDockets: [], alertMessage: errorText });
                }
                else {
                    this.setState({ unfinalisedDockets: data, alertMessage: "" });
                }

            })
            .catch(error => {
                this.setState({ unfinalisedDockets: [], alertMessage: error });
            });
    }
    initialiseRF_TransferGlobalVariables() {
        MyGlobal.rf_transfer = JSON.stringify({
            fromLocationId: 0,
            fromLocationBarcode: "",
            isInventoryAvailableOnTransfer: false,
            createdDocket: 0,
            namecode: "",
            inventoriesInTransfer: [],
            clientName:""

        });
    }
    resumeTransfer(selectedDocket) {

        MyGlobal.rf_transfer = JSON.stringify({
            createdDocket: selectedDocket.docketID,
            namecode: selectedDocket.namecode,
            clientName: selectedDocket.clientName
        });

        this.history.push({
            pathname: 'RFTransfers/RF_SelectAction',
            state: { resumeTransfer: true, createdDocket: selectedDocket.docketID, namecode: selectedDocket.namecode }
        });



    }

    render() {
        const data = [
            {
                menuName: 'Location Transfer',
                path: 'LocationToLocation'
            },
            //{
            //    menuName: 'Adhoc Advanced',
            //    path: 'AdhocTransfer'
            //},
            //{
            //    menuName: 'Adhoc Basic',
            //    path: 'AdhocTransferBasic'
            //},
            {
                menuName: 'Product Transfer',
                path: 'RFTransfers/RF_AdhocTransfer'
            },
            {
                menuName: 'Transfer History',
                path: 'RFTransfers/RF_TransferHistory'
            }
        ];

        let unfinalisedDocketsHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderUnfinalisedDockets();

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return (
            <div>
                <Container>
                    <Row>
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row>
                        <Col>
                            <MenuComponent menuData={data} history={this.history} />
                        </Col>
                    </Row>
                    <Row>
                        <Col> <button type="button" className="btn btn-info col-12 mb-2" onClick={() => { this.clearAll(); }}>Clear</button></Col>
                    </Row>
                    <Row>
                        <Col>
                            <h5>Unfinalised Dockets : {this.state.unfinalisedDockets.length}</h5>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {unfinalisedDocketsHtml}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }

    renderUnfinalisedDockets() {

        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead style={{ position: 'sticky', top: -2, background :'white' }}>
                        <tr>
                            <th className="col-sm-4">
                                <label>Client</label>
                                <br />
                                <input className="col-sm-4" ref="namecodeInput" value={this.state.selectedClient} onChange={(e) => { this.setState({ selectedClient: e.target.value }); }} />
                            </th>
                            <th className="col-sm-4">
                                <label>Docket</label>
                                <br />
                                <input className="col-sm-4" value={this.state.selectedDocket} onChange={(e) => { this.setState({ selectedDocket: e.target.value }); }} /> <br />
                            </th>
                            <th className="col-sm-4">
                                <label>Reference</label>
                                <br />
                                <input className="col-sm-4" value={this.state.selectedReference} onChange={(e) => { this.setState({ selectedReference: e.target.value }); }} />
                            </th>
                            <th className="col">
                                <label>Created</label>
                                <br />
                                <input className="col" value={this.state.selectedCreatedDate} onChange={(e) => { this.setState({ selectedCreatedDate: e.target.value }); }} />
                            </th>
              


                        </tr>
                    </thead>
                    <tbody>
                        {this.state.unfinalisedDockets
                            .filter((item) =>

                                (!this.state.selectedClient.length ||

                                    item.clientName
                                        .toString()
                                        .toLowerCase()
                                    .includes(this.state.selectedClient.toString().toLowerCase())


                                ) &&
                                (!this.state.selectedDocket.length ||

                                    item.docketID
                                        .toString()
                                        .toLowerCase()
                                        .includes(this.state.selectedDocket.toString().toLowerCase())
                                )
                                &&
                                (!this.state.selectedReference.length ||

                                    item.reference
                                        .toString()
                                        .toLowerCase()
                                        .includes(this.state.selectedReference.toString().toLowerCase())
                                )
                                &&
                                (!this.state.selectedCreatedDate.length ||

                                    item.eta
                                        .toString()
                                        .toLowerCase()
                                        .includes(this.state.selectedCreatedDate.toString().toLowerCase())
                                )
                            )
                            .map(row =>
                                <tr key={row.docketID + row.namecode} onClick={() => { this.resumeTransfer(row) }} >
                                    <td>{row.clientName}</td>
                                    <td>{row.docketID}</td>
                                    <td>{row.reference}</td>
                                    <td>{row.eta} </td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        );
    }
}
